import { useEffect, useState } from "react";
import { FiSearch, FiMapPin, FiSliders } from "react-icons/fi";
import Button from "../../component/ui/Button";
import {
  CONNECTIONS_STATUS,
  dropdownItems,
  FILTER_USER_TYPES,
  USER_TYPE,
} from "../../helper/constant";
import { useNavigate } from "react-router-dom";
import PageHeading from "component/ui/PageHeading";
import { useLoginData } from "component/common/loginData";
import { useDispatch, useSelector } from "react-redux";
import {
  disConnectConnection,
  getAcceptConnectionList,
  getPMUsersList,
  SendConnectRequest,
} from "store/slice/booking";
import { getMaxValue } from "helper/appConstant";
import { LuPlus } from "react-icons/lu";
import { GrView } from "react-icons/gr";
import { FaTrophy } from "react-icons/fa";
import { MdOutlineMessage } from "react-icons/md";
import { IoMdClose } from "react-icons/io";
import ConfirmationDialog from "component/dialogs/ConfirmationDialog";
import FullPageLoader from "component/ui/fullPageLoader";
import LocationPicker from "component/ui/LocationPicker";

export default function Community() {
  const [activeTab, setActiveTab] = useState("playmatez");
  const [dropdown, setDropdown] = useState(false);
  const { playmatezUserListData, playmatezConnectionList } = useSelector(
    (state) => state.booking
  );
  const [filterData, setFilterData] = useState({ userTypes: [] });
  const [dialogData, setDialogData] = useState({});
  const navigate = useNavigate();
  const handleDropdown = () => setDropdown(!dropdown);
  const mainColor = "#2BACE2";
  const userData = useLoginData();
  const dispatch = useDispatch();
  useEffect(() => {
    if (userData) {
      setDialogData((dialogData) => ({
        ...dialogData,
        loader: true,
      }));
      fetchUsersList();
      fetchConnectionList();
    }
  }, [userData]);

  // fetch playmatez users list
  const fetchUsersList = (page, search, lat, lng, userTypes) => {
    const request = {
      language: null,
      page: page ?? 1,
      perPage: 12,
      search: search ?? filterData?.search ?? "",
      latitude: lat
        ? lat
        : filterData?.lat ?? userData?.location?.coordinates?.length == 2
        ? userData?.location?.coordinates[1]
        : "",
      longitude: lng
        ? lng
        : filterData?.lng ?? userData?.location?.coordinates?.length == 2
        ? userData?.location?.coordinates[0]
        : "",
      userTypes: userTypes ? userTypes : filterData?.userTypes ?? [],
    };
    dispatch(getPMUsersList(request, setDialogData));
  };
  // fetch connection list
  const fetchConnectionList = (page, search) => {
    dispatch(
      getAcceptConnectionList(
        page ?? 1,
        12,
        search ?? filterData?.connectionSearch ?? ""
      )
    );
  };
  // handle connect disconnect success
  const handleSuccess = () => {
    setDialogData({});
  };
  // handle send connection request
  const handleConnectDisconnectRequest = () => {
    setDialogData((dialogData) => ({
      ...dialogData,
      loader: true,
      show: false,
    }));
    if (dialogData?.type == "connect") {
      dispatch(SendConnectRequest(dialogData?.id, handleSuccess));
    } else {
      const request = { connectUserId: dialogData?.id };
      dispatch(disConnectConnection(request, handleSuccess));
    }
  };
  // get connection status
  const getConnectionStatus = (status) => {
    if (status == 1) {
      return (
        <div className="bg-green-200 text-green-600 font-semibold px-2 py-1 rounded-full text-xs text-center">
          Connected
        </div>
      );
    }
    if (status == 0) {
      return (
        <div className="bg-orange-200 text-orange-600 font-semibold px-2 py-1 rounded-full text-xs text-center">
          Pending
        </div>
      );
    }
    if (status == 3) {
      return (
        <div className="bg-red-200 text-red-600 font-semibold px-2 py-1 rounded-full text-xs text-center">
          Rejected
        </div>
      );
    }
    return null;
  };
  return (
    <div className="min-h-screen bg-gray-100 md:p-5 p-3">
      <div className="container mx-auto">
        {/* Header */}
        {dialogData?.loader && <FullPageLoader />}
        <div className="flex md:flex-row flex-col md:items-center justify-between">
          <PageHeading title={"Community"} />
        </div>

        <div className={`w-full transition-all`}>
          {/* Main Card */}
          <div className="rounded-xl shadow-xl bg-white border border-gray-200 overflow-hidden w-full">
            {/* Tabs */}
            <div className="flex justify-between border-b px-6 border-gray-200">
              {["playmatez", "members"].map((tab) => (
                <button
                  key={tab}
                  onClick={() => setActiveTab(tab)}
                  className={`md:px-6 px-3 py-3 w-1/2 font-medium transition-all text-sm relative ${
                    activeTab === tab
                      ? "text-gray-900"
                      : "text-gray-400 hover:text-gray-900"
                  }`}
                >
                  {tab.charAt(0).toUpperCase() + tab.slice(1)}
                  {activeTab === tab && (
                    <div
                      className="absolute bottom-0 left-0 right-0 h-0.5"
                      style={{ backgroundColor: mainColor }}
                    ></div>
                  )}
                </button>
              ))}
            </div>
            {/* playmatez section */}
            {activeTab == "playmatez" && (
              <>
                {/* Search + Location + Filter */}
                <div className="md:p-6 p-3 border-b border-gray-200">
                  <div className="w-full flex flex-col md:flex-row gap-3 md:gap-6 items-center justify-between">
                    {/* Search Input */}
                    <div className="relative w-full md:w-1/2">
                      <FiSearch
                        className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5"
                        style={{ color: mainColor }}
                      />
                      <input
                        type="text"
                        placeholder={
                          activeTab === "members"
                            ? "Search Members"
                            : "Search Playmatez"
                        }
                        value={filterData?.search}
                        onChange={(e) => {
                          setFilterData((pre) => ({
                            ...pre,
                            search: e.target.value,
                          }));
                          fetchUsersList(null, e.target.value);
                        }}
                        className="w-full md:py-3 py-2 px-2 pl-12 pr-4 text-sm border-2 border-gray-300 rounded-lg outline-none focus:outline-none focus:ring-0 focus:border-[#2BACE2] focus-visible:outline-none"
                      />
                    </div>
                    {/* Right side: Location (conditional) + Filter button */}
                    <div className="flex items-center gap-3 w-full md:w-1/2 justify-end">
                      <div className="relative w-full">
                        {/* <FiMapPin
                          className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5"
                          style={{ color: mainColor }}
                        /> */}
                        <LocationPicker
                          onChange={(place) => {
                            setFilterData((prev) => ({
                              ...prev,
                              lat: place?.geometry?.location?.lat(),
                              lng: place?.geometry?.location?.lng(),
                              address: place?.formatted_address,
                            }));

                            fetchUsersList(
                              null,
                              null,
                              place?.geometry?.location?.lat(),
                              place?.geometry?.location?.lng()
                            );
                          }}
                          value={filterData?.address}
                          placeholder={"search an address"}
                        />
                      </div>
                      <div className="relative inline-block text-left">
                        <button
                          className="md:p-3 p-2 rounded-lg bg-white border border-gray-300 hover:bg-gray-50 flex items-center justify-center"
                          onClick={handleDropdown}
                        >
                          <FiSliders
                            className="w-5 h-5"
                            style={{ color: mainColor }}
                          />
                        </button>

                        {/* Dropdown */}
                        <div
                          className={`absolute right-0 mt-2 z-10 ${
                            dropdown ? "" : "hidden"
                          } bg-white divide-y divide-gray-100 rounded-lg shadow-sm w-40`}
                        >
                          <ul className="py-2 text-sm text-white bg-gray-900">
                            {FILTER_USER_TYPES?.map((item, index) => (
                              <li key={index}>
                                <div className="flex justify-between items-center p-2">
                                  <span className="font-semibold">
                                    {item?.name}
                                  </span>
                                  <input
                                    onClick={() => {
                                      let temp = [...filterData?.userTypes];
                                      if (temp.includes(item?.id)) {
                                        temp = temp.filter(
                                          (user) => user != item?.id
                                        );
                                      } else {
                                        temp.push(item?.id);
                                      }
                                      setFilterData((filterData) => ({
                                        ...filterData,
                                        userTypes: temp,
                                      }));
                                      fetchUsersList(
                                        null,
                                        null,
                                        null,
                                        null,
                                        temp
                                      );
                                    }}
                                    type="checkbox"
                                    className="h-5 w-5"
                                  />
                                </div>
                              </li>
                            ))}
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {/* Members Cards */}
                <div className="md:p-6 p-3 h-[78vh] overflow-y-scroll">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {playmatezUserListData?.data?.map((member) => (
                      <div
                        key={member?.id}
                        className="group rounded-lg md:p-6 p-3 shadow hover:shadow-lg transition-all  bg-white border border-gray-200"
                      >
                        <div className="flex items-start md:space-x-4 space-x-2">
                          <div className="relative">
                            {member?.profileImageUrl ? (
                              <img
                                src={member?.profileImageUrl}
                                alt={""}
                                className="md:w-12 md:h-12 w-8  rounded-2xl object-cover ring-2"
                                style={{ borderColor: mainColor }}
                              />
                            ) : (
                              <div className="md:w-12 md:h-12 w-8 flex justify-center items-center font-semibold text-white  rounded-2xl bg-highlight ring-2">
                                {member?.name &&
                                  member?.name?.charAt(0)?.toUpperCase()}
                              </div>
                            )}
                            {member?.online && (
                              <div
                                className="absolute -bottom-1 -right-1 w-4 h-4 rounded-full border-2 border-white"
                                style={{ backgroundColor: mainColor }}
                              ></div>
                            )}
                          </div>
                          <div className="w-full flex justify-between">
                            <div>
                              <h3 className="text-md  line-clamp-2 w-full font-medium text-gray-900 ">
                                {member?.name}
                              </h3>
                              <p className="text-highlight flex gap-1 font-semibold text-sm">
                                <FaTrophy size={16} />{" "}
                                {member?.userType &&
                                  USER_TYPE[member?.userType]}
                                {member?.connectionData &&
                                  getConnectionStatus(
                                    member?.connectionData?.status
                                  )}
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <div
                                onClick={() => {
                                  navigate(`/player-details/${member?.id}`);
                                }}
                                className="h-8 w-8 flex cursor-pointer justify-center items-center border-2 border-highlight rounded-full bg-[#2bace233]"
                              >
                                <GrView className="h-4 w-4" color="#2bace2" />
                              </div>
                              {member?.connectionData?.status == 1 && (
                                <div
                                  onClick={() =>
                                    navigate(
                                      `/messages?type=connections&id=${member?.id}`
                                    )
                                  }
                                  className="h-8 w-8 flex cursor-pointer justify-center items-center border-2 border-highlight rounded-full bg-[#2bace233]"
                                >
                                  <MdOutlineMessage
                                    className="h-4 w-4"
                                    color="#2bace2"
                                  />
                                </div>
                              )}
                              {member?.connectionData?.status != 0 &&
                                member?.connectionData?.status != 1 && (
                                  <div
                                    onClick={() => {
                                      setDialogData({
                                        message: `Are you sure you want to send connection request to ${member?.name}? `,
                                        show: true,
                                        type: "connect",
                                        id: member?.id,
                                      });
                                    }}
                                    className="h-8 w-8 flex cursor-pointer justify-center items-center border-2 border-highlight rounded-full bg-[#2bace233]"
                                  >
                                    <LuPlus
                                      className="h-5 w-5"
                                      color="#2bace2"
                                    />
                                  </div>
                                )}
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* view more button */}
                  {playmatezUserListData?.totalCount >
                    playmatezUserListData?.data?.length && (
                    <div className="flex justify-center py-3">
                      <Button
                        children={"View More"}
                        onClick={() => {
                          fetchUsersList(
                            getMaxValue(
                              playmatezUserListData?.data?.length,
                              12
                            ) + 1
                          );
                        }}
                      />
                    </div>
                  )}
                </div>
              </>
            )}

            {/* member section */}
            {activeTab == "members" && (
              <>
                <div className="md:p-6 p-3 border-b border-gray-200">
                  <div className="w-full flex flex-col md:flex-row gap-3 md:gap-6 items-center justify-between">
                    {/* Search Input */}
                    <div className="relative w-full md:w-1/2">
                      <FiSearch
                        className="absolute left-4 top-1/2 -translate-y-1/2 w-5 h-5"
                        style={{ color: mainColor }}
                      />
                      <input
                        type="text"
                        placeholder={
                          activeTab === "members"
                            ? "Search Members"
                            : "Search Playmatez"
                        }
                        value={filterData?.connectionSearch}
                        onChange={(e) => {
                          setFilterData((pre) => ({
                            ...pre,
                            connectionSearch: e.target.value,
                          }));
                          fetchConnectionList(null, e.target.value);
                        }}
                        className="w-full md:py-3 py-2 px-2 pl-12 pr-4 text-sm border-2 border-gray-300 rounded-lg outline-none focus:outline-none focus:ring-0 focus:border-[#2BACE2] focus-visible:outline-none"
                      />
                    </div>
                  </div>
                </div>
                {/* Members Cards */}
                <div className="md:p-6 p-3 h-[78vh] overflow-y-scroll">
                  <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
                    {playmatezConnectionList?.data?.map((member) => (
                      <div
                        key={member?.id}
                        className="group rounded-lg md:p-6 p-3 shadow hover:shadow-lg transition-all  bg-white border border-gray-200"
                      >
                        <div className="flex items-start md:space-x-4 space-x-2">
                          <div className="relative">
                            {member?.profileImageUrl ? (
                              <img
                                src={member?.profileImageUrl}
                                alt={""}
                                className="md:w-12 md:h-12 w-8  rounded-2xl object-cover ring-2"
                                style={{ borderColor: mainColor }}
                              />
                            ) : (
                              <div className="md:w-12 md:h-12 w-8 flex justify-center items-center font-semibold text-white  rounded-2xl bg-highlight ring-2">
                                {member?.name &&
                                  member?.name?.charAt(0)?.toUpperCase()}
                              </div>
                            )}
                          </div>
                          <div className="w-full flex justify-between">
                            <div>
                              <h3 className="text-md  line-clamp-2 w-full font-medium text-gray-900 ">
                                {member?.name}
                              </h3>
                              <p className="text-highlight flex gap-1 font-semibold text-sm">
                                <FaTrophy size={16} />{" "}
                                {member?.userType &&
                                  USER_TYPE[member?.userType]}
                              </p>
                            </div>
                            <div className="flex gap-2">
                              <div
                                onClick={() => {
                                  navigate(`/player-details/${member?.sId}`);
                                }}
                                className="h-8 w-8 flex cursor-pointer justify-center items-center border-2 border-highlight rounded-full bg-[#2bace233]"
                              >
                                <GrView className="h-4 w-4" color="#2bace2" />
                              </div>
                              <div
                                onClick={() =>
                                  navigate(
                                    `/messages?type=connections&id=${member?.sId}`
                                  )
                                }
                                className="h-8 w-8 flex cursor-pointer justify-center items-center border-2 border-highlight rounded-full bg-[#2bace233]"
                              >
                                <MdOutlineMessage
                                  className="h-4 w-4"
                                  color="#2bace2"
                                />
                              </div>
                              <div
                                onClick={() => {
                                  setDialogData({
                                    message: `Are you sure you want to remove ${member?.name} from your connection ? `,
                                    show: true,
                                    type: "disconnect",
                                    id: member?.sId,
                                  });
                                }}
                                className="h-8 w-8 flex cursor-pointer justify-center items-center border-2 border-highlight rounded-full bg-[#2bace233]"
                              >
                                <IoMdClose
                                  className="h-4 w-4"
                                  color="#2bace2"
                                />
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                  {/* view more button */}
                  {playmatezConnectionList?.totalCount >
                    playmatezConnectionList?.data?.length && (
                    <div className="flex justify-center py-3">
                      <Button
                        children={"View More"}
                        onClick={() => {
                          fetchConnectionList(
                            getMaxValue(
                              playmatezConnectionList?.data?.length,
                              12
                            ) + 1
                          );
                        }}
                      />
                    </div>
                  )}
                </div>
              </>
            )}
          </div>
        </div>

        {/* confirmation dialog */}
        <ConfirmationDialog
          onConfirm={handleConnectDisconnectRequest}
          closeDialog={() => {
            setDialogData({});
          }}
          cancelButtonName="No"
          actionButtonName="Yes"
          buttonShow={["actionButton", "Cancel"]}
          isDialogOpen={{
            open: dialogData?.show,
            message: dialogData?.message,
          }}
        />
      </div>
    </div>
  );
}
